import { render, staticRenderFns } from "./FlipCard.vue?vue&type=template&id=37a1f8a8&scoped=true&lang=pug&"
import script from "./FlipCard.vue?vue&type=script&lang=ts&"
export * from "./FlipCard.vue?vue&type=script&lang=ts&"
import style0 from "./FlipCard.vue?vue&type=style&index=0&id=37a1f8a8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a1f8a8",
  null
  
)

export default component.exports